/**
 * Routes that need the full window width, so the app sider collapses while they are
 * open (and the rep's own choice comes back on leaving). Today: the proposal editor
 * (spec §3.1 "full-width"; Phase Z, the 1280 px note) — its 8.5 in sheets plus the
 * rail did not fit a 1280 px laptop window beside the open sider.
 *
 * Pure (no React): MainLayout decides with it.
 */
import { matchPath } from "react-router-dom";
import { routes } from "@/config/routes";

const FULL_WIDTH_ROUTES = [routes.proposals.edit];

export function collapsesSider(pathname: string): boolean {
  return FULL_WIDTH_ROUTES.some((pattern) => matchPath(pattern, pathname) !== null);
}

/**
 * The sider after the window crosses the small-device breakpoint: collapsed on a
 * small window, open on a wide one — except on a full-width route, where it stays
 * collapsed (final review M8).
 */
export function collapsedAfterBreakpoint(isSmall: boolean, fullWidth: boolean): boolean {
  return isSmall || fullWidth;
}

/**
 * The sider state given back on leaving a full-width route: the rep's choice from
 * before it, unless the window crossed the small-device breakpoint meanwhile — then
 * the default for the current size, so an open sider never comes back over a
 * phone-width page (final review M8).
 */
export function collapsedOnLeave(s: { before: boolean; smallAtEntry: boolean; smallNow: boolean }): boolean {
  return s.smallAtEntry === s.smallNow ? s.before : s.smallNow;
}
